import { FC } from "react";
import { PageItem } from "./PageItem";
import { FirstPageIcon, LastPageIcon, PrevIcon, NextIcon } from "./Icons";

interface PaginationProps {
    totalPages: number;
    currentPage: number;
    onChange: (page: number) => void;
    endButtons?: boolean;
    maxPages?: number;
}

export const Pagination: FC<PaginationProps> = ({
    totalPages,
    currentPage,
    onChange,
    endButtons,
    maxPages = 6,
}) => {
    console.log('maxPages: ', maxPages);
    const pageItems = [];
    let startPage = Math.floor(currentPage / maxPages) * maxPages;
    let endPage = Math.min(startPage + maxPages, totalPages);
    for (let i = startPage; i < endPage; i++) {
        pageItems.push(
            <PageItem
                key={i + 1}
                number={i + 1}
                active={i === currentPage}
                onClick={() => onChange(i)}
            />
        );
    }

    const isFirstPage = currentPage <= 0;
    const isLastPage = currentPage >= totalPages - 1;

    return (
        <div className="flex justify-center gap-2 items-center min-h-12 pt-4">
            {endButtons && <PageItem key="start" disabled={isFirstPage} onClick={() => onChange(0)} number={<FirstPageIcon />} />}
            <PageItem key="prev" disabled={isFirstPage} onClick={() => onChange(!isFirstPage ? currentPage - 1 : 0)} number={<PrevIcon />} />
            {pageItems}
            <PageItem key="next" disabled={isLastPage} onClick={() => onChange(!isLastPage ? currentPage + 1 : currentPage)} number={<NextIcon />} />
            {endButtons && <PageItem key="end" disabled={isLastPage} onClick={() => onChange(totalPages - 1)} number={<LastPageIcon />} />}
        </div>
    );
};
